export class ClassIdRequestModel {
    classId: number;
    constructor(classId: number) {
        this.classId = classId;
    }
}